import React from 'react'
import { useDesignStore } from '../../store/designStore'
import * as THREE from 'three'

const CanvasBoundary: React.FC = () => {
  const { canvasSettings } = useDesignStore()

  // Create boundary lines
  const boundaryGeometry = React.useMemo(() => {
    const geometry = new THREE.BufferGeometry()
    const halfWidth = canvasSettings.width / 2
    const halfHeight = canvasSettings.height / 2
    
    // Create boundary rectangle points
    const points = [
      // Bottom edge
      new THREE.Vector3(-halfWidth, 0.05, -halfHeight),
      new THREE.Vector3(halfWidth, 0.05, -halfHeight),
      // Right edge
      new THREE.Vector3(halfWidth, 0.05, -halfHeight),
      new THREE.Vector3(halfWidth, 0.05, halfHeight),
      // Top edge
      new THREE.Vector3(halfWidth, 0.05, halfHeight),
      new THREE.Vector3(-halfWidth, 0.05, halfHeight),
      // Left edge
      new THREE.Vector3(-halfWidth, 0.05, halfHeight),
      new THREE.Vector3(-halfWidth, 0.05, -halfHeight),
    ]
    
    geometry.setFromPoints(points)
    return geometry
  }, [canvasSettings.width, canvasSettings.height])

  // Create corner markers
  const cornerGeometry = React.useMemo(() => {
    const geometry = new THREE.SphereGeometry(0.2, 8, 6)
    return geometry
  }, [])

  const halfWidth = canvasSettings.width / 2
  const halfHeight = canvasSettings.height / 2

  return (
    <group>
      {/* Boundary lines */}
      <lineSegments geometry={boundaryGeometry}>
        <lineBasicMaterial 
          color="#ff6b6b" 
          transparent
          opacity={0.6}
        />
      </lineSegments>
      
      {/* Corner markers */}
      <mesh position={[-halfWidth, 0.1, -halfHeight]}>
        <primitive object={cornerGeometry} />
        <meshBasicMaterial color="#ff6b6b" transparent opacity={0.8} />
      </mesh>
      
      <mesh position={[halfWidth, 0.1, -halfHeight]}>
        <primitive object={cornerGeometry} />
        <meshBasicMaterial color="#ff6b6b" transparent opacity={0.8} />
      </mesh>
      
      <mesh position={[halfWidth, 0.1, halfHeight]}>
        <primitive object={cornerGeometry} />
        <meshBasicMaterial color="#ff6b6b" transparent opacity={0.8} />
      </mesh>
      
      <mesh position={[-halfWidth, 0.1, halfHeight]}>
        <primitive object={cornerGeometry} />
        <meshBasicMaterial color="#ff6b6b" transparent opacity={0.8} />
      </mesh>

      {/* Safe zone indicator (slightly smaller than boundary) */}
      <mesh position={[0, 0.02, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <ringGeometry args={[Math.min(halfWidth, halfHeight) - 3, Math.min(halfWidth, halfHeight) - 2.5, 32]} />
        <meshBasicMaterial 
          color="#4ecdc4" 
          transparent 
          opacity={0.3}
          side={THREE.DoubleSide}
        />
      </mesh>
    </group>
  )
}

export default CanvasBoundary
